import { render, staticRenderFns } from "./RomaVideo.vue?vue&type=template&id=b7c7cb92&scoped=true&"
import script from "./RomaVideo.vue?vue&type=script&lang=js&"
export * from "./RomaVideo.vue?vue&type=script&lang=js&"
import style0 from "./RomaVideo.vue?vue&type=style&index=0&id=b7c7cb92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c7cb92",
  null
  
)

export default component.exports